import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a view for saving account information.
 * @extends JetView
 */
export default class tableSaveAccountView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date formatting function based on the app's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in nested functions
        var vthis = this;
        // Initialize an empty data array for the treetable
        const data = [];
        // Return the configuration object for the treetable component
        return {
            view: 'treetable', // Specify the view type as 'treetable'
            id: 'treetable', // Set the unique identifier for the treetable
            css: 'webix_header_border webix_data_border webix_footer_border', // Apply CSS classes for styling
            select: true, // Enable row selection
            scheme: {
                $group: {
                    by: 'ProductsThird', // Group data by 'ProductsThird' field
                    map: {
                        BetShop: ['BetShop', 'string'], // Map 'BetShop' as a string
                        Quota: ['Quota', 'sum'], // Map 'Quota' as a sum
                    },
                },
            },
            // Conditional scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Set height based on screen width
            height: screen.width < 820 ? 410 : 0,
            columns: [
                {
                    id: 'BetShop', // Unique identifier for the column
                    header: _('Punto de Venta'), // Header text, localized
                    width: 350, // Set the width of the column
                    // Template function to render the cell content
                    template: function(obj, common) {
                        if (obj.$group)
                            // Check if the current object is a group
                            return common.treetable(obj, common) + obj.value; // Render group row
                        return obj.BetShop; // Render individual row
                    },
                },
                { id: 'UserId', header: _('ID Usuario'), width: 100 }, // Column for User ID
                { id: 'Quota', header: _('Cupo'), width: 120 }, // Column for Quota
            ],
            // Event handler for click events on the 'edit' action
            onClick: {
                edit: function(euv, id) {
                    vthis.app.callEvent('openEdit', [{}]); // Trigger 'openEdit' event
                },
            },
            tooltip: true, // Enable tooltips for the treetable
            math: true, // Enable mathematical operations in the treetable
            loadahead: devConfig.getDefaultDataFetch(), // Set the data fetch configuration
            pager: 'pagerA', // Specify the pager component ID
            data: data, // Bind the data array to the treetable
            // Set the URL for fetching data from the API
            url: devConfig.geturlApi() + 'Accounting/GetProductsThirdQuota',
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        var url = grid.data.url; // URL for data retrieval
        var filter = ''; // Filter string for data queries
        const _ = this.app.getService('locale')._; // Localization service for translations
        var productsThird = []; // Array to hold third-party products
        var popup = ''; // Variable to hold the edit popup
        var popupAdd = ''; // Variable to hold the add popup

        webix
            .ajax() // Initiating an AJAX request
            .headers({
                'Content-type': 'application/json', // Setting the content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetProductsThirdQuotaSelect', '', {
                error: function(text, data, XmlHttpRequest) { // Error handling for the AJAX request
                    webix.message(_('Error! ')); // Displaying an error message
                },
                success: function(text, data, XmlHttpRequest) { // Success handling for the AJAX request
                    var resp = JSON.parse(text); // Parsing the response text to JSON
                    productsThird = resp.Data; // Storing the data in productsThird array
                    productsThird.splice(0, 0, { // Adding a default option to the productsThird array
                        id: '',
                        value: _('Todos'), // Localized label for 'All'
                    });
                    console.log(productsThird); // Logging the productsThird array for debugging
                    popup = webix.ui({ // Creating a popup window for editing
                        view: 'window',
                        width: 700,
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Editar Cupo') }, // Localized label for 'Edit Quota'
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon for the popup
                                    click: function() {
                                        this.getTopParentView().hide(); // Hiding the popup on click
                                    },
                                },
                            ],
                        },
                        position: 'center', // Centering the popup on the screen
                        modal: true, // Making the popup modal
                        body: {
                            view: 'form', // Form inside the popup
                            id: 'editForm', // ID for the form
                            elements: [
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Dropdown for selecting third-party products
                                            label: _('Producto Tercero'), // Localized label for 'Third-Party Product'
                                            name: 'ProductsThird',
                                            options: productsThird, // Options populated from productsThird array
                                            labelWidth: 150,
                                            id: 'selectProductsThird2', // ID for the combo
                                            placeholder: _('Click para seleccionar '), // Placeholder text
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button', // CSS class for styling
                                            view: 'button', // Button to open the search window
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass', // Search icon
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({ // Creating a search window for third-party products
                                                        view: 'window',
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Productos Terceros'), // Localized label for 'Third-Party Products'
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close', // Close icon for the search window
                                                                    click: function() {
                                                                        this.getTopParentView().hide(); // Hiding the search window on click
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchProductsThird2', // ID for the search window
                                                        modal: true, // Making the search window modal
                                                        position: 'center', // Centering the search window
                                                        width: 425,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying products
                                                                    select: true, // Allowing selection of rows
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id', // Column header for ID
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'), // Localized header for 'Name'
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Allowing the column to fill space
                                                                        },
                                                                    ],
                                                                    data: productsThird, // Data for the table
                                                                    on: {
                                                                        onItemDblClick: function(id) { // Double-click event on table rows
                                                                            var item = this.getItem(id); // Getting the clicked item
                                                                            $$('selectProductsThird2').setValue(item.id); // Setting the selected value
                                                                            $$('searchProductsThird2').hide(); // Hiding the search window
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Showing the search window
                                            },
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Dropdown for selecting Bet Shop
                                            name: 'BetShopId',
                                            label: _('Punto de Venta'), // Localized label for 'Point of Sale'
                                            labelWidth: 150,
                                            placeholder: _('Click para seleccionar '), // Placeholder text
                                            id: 'selectBetShopId2', // ID for the combo
                                            options: {
                                                body: {
                                                    dataFeed: function(text) { // Function to fetch Bet Shops based on input
                                                        var vthis = this; // Reference to the current context
                                                        if (text.length > 2) { // Checking if input length is greater than 2
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Setting content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint for fetching Bet Shops
                                                                    '{"Filter":"' + text + '"}', // Sending filter as request body
                                                                    {
                                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                                            webix.message('Error! '); // Displaying error message
                                                                        },
                                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                                            var resp = JSON.parse(text); // Parsing response
                                                                            if (!resp.HasError) { // Checking for errors in response
                                                                                vthis.parse(resp.Data); // Parsing data into the combo options
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                },
                                            },
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button', // CSS class for styling
                                            view: 'button', // Button to open the search window for Bet Shops
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass', // Search icon
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({ // Creating a search window for Bet Shops
                                                        view: 'window',
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Punto de Venta'), // Localized label for 'Point of Sale'
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close', // Close icon for the search window
                                                                    click: function() {
                                                                        this.getTopParentView().hide(); // Hiding the search window on click
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchBetShop2', // ID for the search window
                                                        modal: true, // Making the search window modal
                                                        position: 'center', // Centering the search window
                                                        width: 425,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying Bet Shops
                                                                    select: true, // Allowing selection of rows
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id', // Column header for ID
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'), // Localized header for 'Name'
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Allowing the column to fill space
                                                                        },
                                                                    ],
                                                                    data: profile.BetShops, // Data for the table
                                                                    on: {
                                                                        onItemDblClick: function(id) { // Double-click event on table rows
                                                                            var item = this.getItem(id); // Getting the clicked item
                                                                            $$('selectBetShopId2').setValue(item.id); // Setting the selected value
                                                                            $$('searchBetShop2').hide(); // Hiding the search window
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Showing the search window
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'text', // Text input for quota
                                    label: _('Cupo'), // Localized label for 'Quota'
                                    name: 'Quota',
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button', // Cancel button
                                            value: _('Cancelar'), // Localized label for 'Cancel'
                                            click: function() {
                                                this.getTopParentView().hide(); // Hiding the popup
                                               $$('editForm').setValues($$('editForm').getCleanValues()); // Resetting form values
                                            },
                                        },
                                        {
                                            view: 'button', // Save button
                                            type: 'form',
                                            value: _('Guardar'), // Localized label for 'Save'
                                            click: function($e) {
                                                var values =$$('editForm').getValues(); // Getting form values
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Accounting/SaveAccount', // API endpoint for saving account
                                                        '{"ProductsThird":"' +
                                                        values.ProductsThird +
                                                        '", "BetShop":"' +
                                                        values.BetShop +
                                                        '", "Quota":"' +
                                                        values.Quota +
                                                        '"}', // Sending form data as request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) { // Error handling
                                                                webix.message(_('Error! ')); // Displaying error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) { // Success handling
                                                                webix.message(_('Cuenta Actualizado')); // Displaying success message
                                                                grid.clearAll(); // Clearing the grid
                                                                grid.load(
                                                                    url +
                                                                    '?start=0&count=' +
                                                                    grid.data.$pagesize +
                                                                    filter, // Reloading the grid with updated data
                                                                );
                                                            },
                                                        },
                                                    );
                                               $$('editForm').setValues($$('editForm').getCleanValues()); // Resetting form values
                                                this.getTopParentView().hide(); // Hiding the popup
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });
                   $$('editForm').bind($$('treetable')); // Binding the form to the tree table
                    popupAdd = webix.ui({ // Creating a popup window for adding
                        view: 'window',
                        width: 450,
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Agregar cupo') }, // Localized label for 'Add Quota'
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon for the popup
                                    click: function() {
                                        this.getTopParentView().hide(); // Hiding the popup on click
                                    },
                                },
                            ],
                        },
                        position: 'center', // Centering the popup on the screen
                        modal: true, // Making the popup modal
                        body: {
                            view: 'form', // Form inside the popup
                            id: 'addform', // ID for the form
                            elements: [
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Dropdown for selecting third-party products
                                            label: _('Producto Tercero'), // Localized label for 'Third-Party Product'
                                            name: 'ProductsThird',
                                            options: productsThird, // Options populated from productsThird array
                                            labelWidth: 150,
                                            required: true, // Making the field required
                                            id: 'selectProductsThird', // ID for the combo
                                            placeholder: _('Click para seleccionar '), // Placeholder text
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button', // CSS class for styling
                                            view: 'button', // Button to open the search window
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass', // Search icon
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({ // Creating a search window for third-party products
                                                        view: 'window',
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Productos Terceros'), // Localized label for 'Third-Party Products'
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close', // Close icon for the search window
                                                                    click: function() {
                                                                        this.getTopParentView().hide(); // Hiding the search window on click
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchProductsThird', // ID for the search window
                                                        modal: true, // Making the search window modal
                                                        position: 'center', // Centering the search window
                                                        width: 425,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying products
                                                                    select: true, // Allowing selection of rows
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id', // Column header for ID
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'), // Localized header for 'Name'
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Allowing the column to fill space
                                                                        },
                                                                    ],
                                                                    data: productsThird, // Data for the table
                                                                    on: {
                                                                        onItemDblClick: function(id) { // Double-click event on table rows
                                                                            var item = this.getItem(id); // Getting the clicked item
                                                                            $$('selectProductsThird').setValue(item.id); // Setting the selected value
                                                                            $$('searchProductsThird').hide(); // Hiding the search window
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Showing the search window
                                            },
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Dropdown for selecting Bet Shop
                                            label: _('Punto de Venta'), // Localized label for 'Point of Sale'
                                            name: 'BetShopId',
                                            labelWidth: 150,
                                            placeholder: _('Click para seleccionar '), // Placeholder text
                                            id: 'selectBetShopId', // ID for the combo
                                            required: true, // Making the field required
                                            options: {
                                                body: {
                                                    dataFeed: function(text) { // Function to fetch Bet Shops based on input
                                                        var vthis = this; // Reference to the current context
                                                        if (text.length > 2) { // Checking if input length is greater than 2
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Setting content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint for fetching Bet Shops
                                                                    '{"Filter":"' + text + '"}', // Sending filter as request body
                                                                    {
                                                                        error: function(text, data, XmlHttpRequest) { // Error handling
                                                                            webix.message('Error! '); // Displaying error message
                                                                        },
                                                                        success: function(text, data, XmlHttpRequest) { // Success handling
                                                                            var resp = JSON.parse(text); // Parsing response
                                                                            if (!resp.HasError) { // Checking for errors in response
                                                                                vthis.parse(resp.Data); // Parsing data into the combo options
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    },
                                                },
                                            },
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button', // CSS class for styling
                                            view: 'button', // Button to open the search window for Bet Shops
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass', // Search icon
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({ // Creating a search window for Bet Shops
                                                        view: 'window',
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Punto de Venta'), // Localized label for 'Point of Sale'
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close', // Close icon for the search window
                                                                    click: function() {
                                                                        this.getTopParentView().hide(); // Hiding the search window on click
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchBetShop', // ID for the search window
                                                        modal: true, // Making the search window modal
                                                        position: 'center', // Centering the search window
                                                        width: 425,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable', // Data table for displaying Bet Shops
                                                                    select: true, // Allowing selection of rows
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id', // Column header for ID
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'), // Localized header for 'Name'
                                                                                {
                                                                                    content: 'textFilter', // Filter for text input
                                                                                },
                                                                            ],
                                                                            fillspace: true, // Allowing the column to fill space
                                                                        },
                                                                    ],
                                                                    data: profile.BetShops, // Data for the table
                                                                    on: {
                                                                        onItemDblClick: function(id) { // Double-click event on table rows
                                                                            var item = this.getItem(id); // Getting the clicked item
                                                                            $$('selectBetShopId').setValue(item.id); // Setting the selected value
                                                                            $$('searchBetShop').hide(); // Hiding the search window
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Showing the search window
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'text', // Text input for quota
                                    label: _('Cupo'), // Localized label for 'Quota'
                                    name: 'Quota',
                                    type: 'number', // Specifying the input type as number
                                    required: true, // Making the field required
                                    labelWidth: 150,
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button', // Cancel button
                                            value: _('Cancelar'), // Localized label for 'Cancel'
                                            click: function() {
                                                this.getTopParentView().hide(); // Hiding the popup
                                                $$('addform').setValues($$('addform').getCleanValues()); // Resetting form values
                                            },
                                        },
                                        {
                                            view: 'button', // Save button
                                            type: 'form',
                                            value: _('Guardar'), // Localized label for 'Save'
                                            click: function($e) {
                                                var values = $$('addform').getValues(); // Getting form values
                                                if ($$('addform').validate()) { // Validating the form
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Setting content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Accounting/SaveProductsThirdQuota', // API endpoint for saving products third quota
                                                            '{"ProductsThird":"' +
                                                            values.ProductsThird +
                                                            '", "BetShopId":"' +
                                                            values.BetShopId +
                                                            '", "Quota":"' +
                                                            values.Quota +
                                                            '"}', // Sending form data as request body
                                                            {
                                                                error: function(text, data, XmlHttpRequest) { // Error handling
                                                                    webix.message({ // Displaying error message
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Ocurrio un error.'),
                                                                    });
                                                                },
                                                                success: function(text, data, XmlHttpRequest) { // Success handling
                                                                    text = JSON.parse(text); // Parsing response
                                                                    if (text.HasError) { // Checking for errors in response
                                                                        webix.message({ // Displaying error message
                                                                            title: _('¡Error!'),
                                                                            type: 'alert-error',
                                                                            text: _('Ocurrio un error.'),
                                                                        });
                                                                    } else {
                                                                        webix.message(_('Cupo Agregado')); // Displaying success message
                                                                        grid.clearAll(); // Clearing the grid
                                                                        grid.load(
                                                                            url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reloading the grid with updated data
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                    $$('addform').setValues($$('addform').getCleanValues()); // Resetting form values
                                                    this.getTopParentView().hide(); // Hiding the popup
                                                } else {
                                                    webix.message({ // Displaying validation error message
                                                        title: _('¡Error!'),
                                                        type: 'alert-error',
                                                        text: _('Completa los campos...'), // Localized message for incomplete fields
                                                    });
                                                }
                                            },
                                        },
                                    ],
                                },
                            ],
                            elementsConfig: {
                                on: {
                                    onChange: function() {
                                        this.validate(); // Validating the form on change
                                    },
                                },
                            },
                        },
                    });
                },
            });

        // Event listener for 'ProductsThird:filter' event on the app instance
        this.on(this.app, 'ProductsThird:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string for filters

            // Iterate through each key-value pair in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query string
                        } else {
                            // Add other filters to query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate through each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create Date object from value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format year
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' + // Format month
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' + // Format day
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' + // Format hours
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' + // Format minutes
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query string
                                } else {
                                    // Handle 'end' date in the nested object
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create Date object from value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format year
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' + // Format month
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' + // Format day
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' + // Format hours
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' + // Format minutes
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event listener for the 'onAfterSort' event on the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                '?start=0&count=' +
                grid.data.$pagesize + // Set the starting point and count for pagination
                filter + // Include any additional filters
                '&sort[' +
                by + // Sort by the specified column
                ']=' +
                dir, // Sort direction (ascending or descending)
            );
        });

        // Listen for the 'addQuota:button' event from the application
        this.on(this.app, 'addQuota:button', (filter) => {
            // Check if there are products available for quota addition
            if (productsThird.length > 0) {
                $$('addform').clearValidation(); // Clear any previous validation errors
                popupAdd.show(); // Show the popup for adding quota
            } else {
                // Display an error message if no products are loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Title of the error message
                    type: 'alert-error', // Type of the message
                });
            }
        });

        // Listen for the 'openEdit' event from the application
        this.on(this.app, 'openEdit', (filterData) => {
            // Check if there are products available for editing
            if (productsThird.length > 0) {
                popup.show(); // Show the popup for editing
            } else {
                // Display an error message if no products are loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Title of the error message
                    type: 'alert-error', // Type of the message
                });
            }
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
